module.exports = __webpack_public_path__ + "img/main-banner.fdaefd37.png";